export default __webpack_public_path__ + "static/media/bankingmenuicon.04718b87.svg";